module.exports = __webpack_public_path__ + "static/img/per8.669a7d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per8.jpg
// module id = cxId
// module chunks = 41